<template>
  <!-- 公共弹窗 -->
  <a-drawer
    :visible="isVisible"
    :width="drawerWidth"
    :closable="false"
    :destroyOnClose="true"
    :get-container="false"
    :wrap-style="{ position: 'absolute' }"
    :after-visible-change="afterVisibleChange"
    class="drawer"
    @close="handleCancel"
  >
    <template slot="title">
      <div style="display:flex;">
        <a-button v-if="buttons" type="primary" icon="login" @click="goNoteClick">返回</a-button>
        <div style="margin-left: 20px; font-size: 18px !important;">[查看]-{{ titles }}</div>
        <!-- <span @click="handleCancel" class="close" style=""><a-icon type="close"/> 关闭</span> -->
        <span class="edit">
          <a-button
            v-if="drawerWidthFlag"
            type="primary"
            icon="fullscreen"
            size="default"
            @click="setDrawerWidth(false)"
          />
          <a-button
            v-if="!drawerWidthFlag"
            type="primary"
            icon="fullscreen-exit"
            size="default"
            @click="setDrawerWidth(true)"
          />
          <a-button
            type="primary"
            icon="edit"
            @click="handleEdit"
            v-if="titles !== this.$tree([], 'offices/travelRecords/index') && titles !== this.$tree([], 'customerManage/resignationsCompensation/index') && titles !== `${this.$tree([], 'inventory/outStock/index')}详情`"
          >编辑</a-button>
          <a-button v-hasPermission="'log:view'" type="primary" icon="eye" @click="logClick">日志</a-button>
        </span>
        <a-button class="close" icon="close" @click="handleCancel">关闭</a-button>
      </div>
    </template>
    <div v-show="loadings">
      <a-spin tip="Loading..." style="height: 400px;">
        <div class="spin-content"></div>
      </a-spin>
    </div>
    <div v-show="!loadings">
      <component
        :isChild="true"
        :is="getName"
        @onClickView="onLoadView"
        ref="componentRef"
        @datasChange="datasChange"
        @projectChange="projectChange"
        @detailClickhuman="datasChange"
        @largeOrExpenseChange="datasChange"
        @detailClickOutwork="datasChange"
      />
    </div>
    <public-edit-dialog
      :title="publicDias.title"
      ref="publicEditDialogRef"
      :dialog-visible="publicDias.visible"
      :component-name="publicDias.comName"
      @logSuccess="publicDialogSucc"
      @handleSuccuse="handleSuccuse"
      @cancel="publicDialogCancel"
    ></public-edit-dialog>
    <public-log-dialog
      :title="publicLogDias.title"
      ref="publicLogDiasRef"
      :dialog-visible="publicLogDias.visible"
      @logSuccess="publicLogDiasSucc"
      @cancel="publicLogDiasCancel"
    ></public-log-dialog>
  </a-drawer>
</template>

<script>
import publicEditDialog from '@/components/modelDialog/publicEditDialog.vue'
import publicLogDialog from '@/components/modelDialog/publicLogDialog.vue'
export default {
  name: 'publicDrawer',
  props: {
    componentName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '选择信息'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: { publicEditDialog, publicLogDialog },
  provide () {
    return {
      fundTypeObj: this.fundTypeObj
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    },
    getName () {
      if (this.componentNames) {
        return (resolve) => require([`@/views/${this.componentNames}`], resolve)
      }
      return null
    }
  },
  data () {
    return {
      publicLogDias: {
        title: '',
        visible: false
      },
      publicDias: {
        title: '',
        visible: false,
        comName: ''
      },
      drawerWidth: '65%',
      drawerWidthFlag: true,
      chooseData: '',
      form: {},
      buttons: true,
      titles: this.title,
      componentNames: this.componentName,
      arr: [],
      loadings: true,
      fundTypeObj: {}
    }
  },
  watch: {
    isVisible (newVal, oldVal) {
      if (newVal) {
        if (this.arr.length <= 1) {
        }
      } else {
        this.arr = []
      }
    },
    arr (newVal, oldVal) {
      if (newVal.length <= 1) {
        this.buttons = false
      } else this.buttons = true
    }
  },
  methods: {
    setDrawerWidth (e) {
      // console.log('setDrawerWidth')
      this.drawerWidthFlag = e
      if (e) {
        this.drawerWidth = '65%'
      } else {
        this.drawerWidth = '100%'
      }
    },
    dicInit () { // 项目资金管理需要的字典
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'fundCostType' }).then(res => {
        res.data.data.forEach(item => {
          this.fundTypeObj[item.dictCode] = item.dictName
        })
      })
    },
    handleSuccuse (data) {
      this.publicDias.visible = false
      this.isVisible = false
      this.$emit('editClick', data, this.publicDias.title, this.publicDias.comName)
    },
    logClick () {
      // console.log(this.titles)
      switch (this.titles) {
        case '预支预付':
          this.goLog('prePayment')
          break
        case this.$tree([], 'inventory/outStock/index'):
        case `${this.$tree([], 'inventory/outStock/index')}详情`:
          this.goLog('stockOut')
          break
        case this.$tree([], 'financialManage/expenseReim/index'):
          this.goLog('reimbursement')
          break
        case this.$tree([], 'purchase/purchaseRequest/index'):
          this.goLog('purchaseRequisition')
          break
        case this.$tree([], 'financialManage/ticketReceiptRecord/index'):
        case this.$tree([], 'financialManage/billingRecords/index'):
          this.goLog('invoice')
          break
        case this.$tree([], 'contractManage/paymentPlan/index'):
        case this.$tree([], 'contractManage/paymentRecord/index'):
          this.goLog('payBack')
          break
        case this.$tree([], 'purchase/paymentSchedule/index'):
        case this.$tree([], 'purchase/paymentRecords/index'):
          this.goLog('payPlan')
          break
        case this.$tree([], 'projectManage/humanCost/index'):
          this.goLog('humanCost')
          break
        case this.$tree([], 'offices/travelRecords/index'):
          this.goLog('outwork')
          break
        case this.$tree([], 'projectManage/fundCost/index'):
          this.goLog('fundCost')
          break
        case this.$tree([], 'offices/courtesyApplication/index'):
          this.goLog('festivalGift')
          break
        case this.$tree([], 'purchase/purchRefundRec/index'):
          this.goLog('payRefund')
          break
        case this.$tree([], 'salesOpportunities/projectOpportunities/index'):
          this.goLog('saleOpportunity')
          break
        case '销售资源':
          this.goLog('saleResource')
          break
        case this.$tree([], 'salesOpportunities/todoTask/index'):
          this.goLog('saleTask')
          break
        case this.$tree([], 'contractManage/contractManagement/index'):
          this.goLog('contractSupplement')
          break
        case '跟进记录':
          this.goLog('opportunityLog')
          break
        case this.$tree([], 'manpower/recruitmentDemand/index'):
          this.goLog('recruitment')
          break
        case this.$tree([], 'contractManage/earnestMoney/index'):
          this.goLog('performanceBond')
          break
        case this.$tree([], 'offices/vehicleDepartureRecord/index'):
          this.goLog('vehicleDepartureRecord')
          break
        default:
          break
      }
    },
    goLog (type) {
      this.publicLogDias.visible = true
      this.publicLogDias.title = '数据操作日志'
      let params = {
        serviceType: type,
        serviceId: `${this.form.id}`
      }
      this.$refs.publicLogDiasRef.getLog(params)
    },
    publicLogDiasCancel () {
      this.publicLogDias.visible = false
    },
    publicLogDiasSucc () {
      this.publicLogDias.visible = false
    },
    publicDialogSucc () {
      this.publicDias.visible = false
    },
    publicDialogCancel () {
      this.publicDias.visible = false
    },
    setForm (form, val) {
      this.titles = this.title
      if (this.title === `${this.$tree([], 'projectManage/fundCost/index')}`) { // 项目资金管理
        this.dicInit()
      }
      this.componentNames = this.componentName
      this.form = form
      this.arr.push({ data: form, componentName: this.componentNames, titles: this.titles })
    },
    goNoteClick () {
      this.loadings = true
      setTimeout(() => {
        this.loadings = false
      }, 200)
      this.arr.pop()
      let item = this.arr[this.arr.length - 1]
      this.datasChange(item.data, item.componentName, item.titles, 0)
    },
    afterVisibleChange () {
      if (this.isVisible) {
        setTimeout(() => {
          if (this.$refs.componentRef) {
            this.$refs.componentRef.setFormData(this.form)
          }
        }, 200)
        setTimeout(() => {
          this.loadings = false
        }, 200)
      } else {
        this.loadings = true
      }
    },
    onLoadView () {
      this.loadings = false
      // this.$refs.componentRef.setFormData(this.form)
      if (this.titles === `${this.$tree([], 'inventory/outStock/index')}详情`) {
        this.$refs.componentRef.setFormData(this.form.id)
      } else {
        this.$refs.componentRef.setFormData(this.form)
      }
    },
    projectChange (value, name) {
      this.$emit('projectChanges', value, name)
    },
    datasChange (data, componentName, title, num) {
      // console.log(data, componentName, title, num, 'publicDrawer')
      this.loadings = true
      setTimeout(() => {
        this.loadings = false
      }, 200)
      this.componentNames = componentName
      this.titles = title
      this.form = data
      if (num !== 0) {
        this.arr.push({ data: data, componentName: componentName, titles: title })
      }
      setTimeout(() => {
        if (this.$refs.componentRef) {
          if (title === `${this.$tree([], 'inventory/outStock/index')}详情`) {
            this.$refs.componentRef.setFormData(data.id)
          } else {
            this.$refs.componentRef.setFormData(data)
          }
        }
      }, 200)
    },
    handleCancel () {
      this.$emit('close')
    },
    handleEdit () {
      // this.$emit('edit')
      this.publicDrawerEdit()
    },
    publicDrawerEdit () {
      // console.log(this.titles, this.componentNames, 'this.titles')
      switch (this.titles) {
        case '预支预付':
          this.publicEditDialogClick('预支预付', 'financialManage/advance/addEdit.vue')
          break
        case '跟进记录':
          this.publicEditDialogClick('跟进记录', 'salesOpportunities/projectOpportunities/followRecords.vue')
          break
        case this.$tree([], 'financialManage/expenseReim/index'):
          this.publicEditDialogClick(this.$tree([], 'financialManage/expenseReim/index'), 'financialManage/expenseReim/addEdit.vue')
          break
        case this.$tree([], 'purchase/purchaseRequest/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/purchaseRequest/index'), 'purchase/purchaseRequest/addEdit.vue')
          break
        case this.$tree([], 'financialManage/ticketReceiptRecord/index'):
          this.publicEditDialogClick(this.$tree([], 'financialManage/ticketReceiptRecord/index'), 'financialManage/ticketReceiptRecord/addEdit.vue')
          break
        case this.$tree([], 'financialManage/billingRecords/index'):
          this.publicEditDialogClick(this.$tree([], 'financialManage/billingRecords/index'), 'financialManage/billingRecords/addEdit.vue')
          break
        case this.$tree([], 'contractManage/paymentPlan/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/paymentPlan/index'), 'contractManage/paymentPlan/addEdit.vue')
          break
        case this.$tree([], 'contractManage/paymentRecord/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/paymentRecord/index'), 'contractManage/paymentRecord/addEdit.vue')
          break
        case this.$tree([], 'purchase/paymentSchedule/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/paymentSchedule/index'), 'purchase/paymentSchedule/addEdit.vue')
          break
        case this.$tree([], 'purchase/paymentRecords/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/paymentRecords/index'), 'purchase/paymentRecords/addEdit.vue')
          break
        case this.$tree([], 'projectManage/humanCost/index'):
          this.publicEditDialogClick(this.$tree([], 'projectManage/humanCost/index'), 'projectManage/humanCost/addEdit.vue')
          break
        case this.$tree([], 'offices/courtesyApplication/index'):
          this.publicEditDialogClick(this.$tree([], 'offices/courtesyApplication/index'), 'offices/courtesyApplication/addEdit.vue')
          break
        case this.$tree([], 'projectManage/fundCost/index'):
          this.publicEditDialogClick(this.$tree([], 'projectManage/fundCost/index'), 'projectManage/fundCost/addEdit.vue')
          break
        case this.$tree([], 'purchase/purchRefundRec/index'):
        case `${this.$tree([], 'inventory/outStock/index')}详情`:
          this.publicEditDialogClick(this.$tree([], 'purchase/purchRefundRec/index'), 'purchase/purchRefundRec/addEdit.vue')
          break
        case this.$tree([], 'contractManage/contractManagement/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/contractManagement/index'), 'contractManage/contractManagement/addEdit.vue')
          break
        case this.$tree([], 'manpower/recruitmentDemand/index'):
          this.publicEditDialogClick(this.$tree([], 'manpower/recruitmentDemand/index'), 'manpower/recruitmentDemand/addEdit.vue')
          break
        case this.$tree([], 'contractManage/earnestMoney/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/earnestMoney/index'), 'contractManage/earnestMoney/addEdit.vue')
          break
        default:
          break
      }
    },
    publicEditDialogClick (title, path) {
      this.publicDias.visible = true
      if (title === '预支预付') {
        if (this.form.paymentType === 0) this.publicDias.title = `[修改]${this.$tree([], 'financialManage/advance/index')}`
        if (this.form.paymentType === 1) this.publicDias.title = `[修改]${this.$tree([], 'financialManage/prepayment/index')}`
      } else {
        this.publicDias.title = '[编辑]-' + title
      }
      this.publicDias.comName = path
      this.$refs.publicEditDialogRef.edit(this.form)
    }
  }
}
</script>
<style lang="less" scoped>
.close {
  position: absolute;
  right: 20px;
}
.edit {
  position: absolute;
  right: 120px;
}
.log {
  position: absolute;
  right: 190px;
}
/deep/ .ant-drawer {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.spin-content {
  // border: 1px solid #91d5ff;
  // background-color: #e6f7ff;
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/publicDrawer.vue